module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('requestforration_list')))]), _vm._v(" "), _c('loading', {
    attrs: {
      "loadingText": ("" + (_vm.$t('loading'))),
      "id": "loadMe",
      "loadinSubText": ("" + (_vm.$t('please_wait')))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "bsModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "bsModalLabel",
      "data-toggle": "modal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(0), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "bsModalLabel"
    }
  }, [_vm._v(_vm._s(_vm.$t('requestforration_form')))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', {
    attrs: {
      "action": ""
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.contactNumber),
      expression: "form.contactNumber"
    }],
    staticClass: "form-control my-input",
    attrs: {
      "type": "text",
      "name": "contactNumber",
      "id": "contactNumber",
      "placeholder": ("" + (_vm.$t('contactNumber')))
    },
    domProps: {
      "value": (_vm.form.contactNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "contactNumber", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.name),
      expression: "form.name"
    }],
    staticClass: "form-control my-input",
    attrs: {
      "type": "text",
      "name": "name",
      "id": "name",
      "placeholder": ("" + (_vm.$t('name')))
    },
    domProps: {
      "value": (_vm.form.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.idNumber),
      expression: "form.idNumber"
    }],
    staticClass: "form-control my-input",
    attrs: {
      "type": "text",
      "name": "idNumber",
      "id": "idNumber",
      "placeholder": ("" + (_vm.$t('idNumber')))
    },
    domProps: {
      "value": (_vm.form.idNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "idNumber", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.age),
      expression: "form.age"
    }],
    staticClass: "form-control my-input",
    attrs: {
      "type": "text",
      "name": "age",
      "id": "age",
      "placeholder": ("" + (_vm.$t('age')))
    },
    domProps: {
      "value": (_vm.form.age)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "age", $event.target.value)
      }, function($event) {
        return _vm.$emit('input', $event)
      }]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.yob),
      expression: "form.yob"
    }],
    staticClass: "form-control my-input",
    attrs: {
      "type": "text",
      "name": "yob",
      "id": "yob",
      "placeholder": ("" + (_vm.$t('yob')))
    },
    domProps: {
      "value": (_vm.form.yob)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "yob", $event.target.value)
      }, function($event) {
        return _vm.$emit('input', $event)
      }]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.gender),
      expression: "form.gender"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "gender", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('gender')))]), _vm._v(" "), _vm._l((_vm.$t('sex')), function(s, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": i
      }
    }, [_vm._v("\n                           " + _vm._s(s) + "\n                          ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.address),
      expression: "form.address"
    }],
    staticClass: "form-control my-input",
    attrs: {
      "type": "text",
      "name": "address",
      "id": "address",
      "placeholder": ("" + (_vm.$t('address')))
    },
    domProps: {
      "value": (_vm.form.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "address", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.city),
      expression: "form.city"
    }],
    staticClass: "form-control my-input",
    attrs: {
      "type": "text",
      "name": "city",
      "id": "city",
      "placeholder": ("" + (_vm.$t('city')))
    },
    domProps: {
      "value": (_vm.form.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "city", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.state),
      expression: "form.state"
    }],
    staticClass: "form-control my-input",
    attrs: {
      "type": "text",
      "name": "state",
      "id": "state",
      "placeholder": ("" + (_vm.$t('state')))
    },
    domProps: {
      "value": (_vm.form.state)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "state", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.zipcode),
      expression: "form.zipcode"
    }],
    staticClass: "form-control my-input",
    attrs: {
      "type": "text",
      "name": "zipcode",
      "id": "zipcode",
      "placeholder": ("" + (_vm.$t('zipcode')))
    },
    domProps: {
      "value": (_vm.form.zipcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "zipcode", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.loading) ? _c('div', [_c('i', {
    staticClass: "fa fa-spin fa-spinner fa-3x"
  })]) : _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn-success ",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.$t('submit')))])]), _vm._v(" "), (_vm.error.length > 0) ? _c('div', {
    staticClass: "alert alert-danger padding5"
  }, _vm._l((_vm.error), function(s, i) {
    return _c('p', {
      key: i
    }, [_vm._v("\n                           \n                            \n                            " + _vm._s(_vm.$t(s)) + "\n                           \n                        ")])
  }), 0) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    on: {
      "click": _vm.openFrom
    }
  }, [_vm._v(_vm._s(_vm.$t('add_new')))])]), _vm._v(" "), _c('div', {
    staticClass: "box-body no-padding table-responsive"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.contactNumber),
      expression: "search.contactNumber"
    }],
    staticClass: "input-group-text",
    attrs: {
      "type": "text",
      "name": "contactNumber",
      "placeholder": ("" + (_vm.$t('contactNumber')))
    },
    domProps: {
      "value": (_vm.search.contactNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "contactNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.name),
      expression: "search.name"
    }],
    staticClass: "input-group-text",
    attrs: {
      "type": "text",
      "name": "name",
      "placeholder": ("" + (_vm.$t('name')))
    },
    domProps: {
      "value": (_vm.search.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.idNumber),
      expression: "search.idNumber"
    }],
    staticClass: "input-group-text",
    attrs: {
      "type": "text",
      "name": "idNumber",
      "placeholder": ("" + (_vm.$t('idNumber')))
    },
    domProps: {
      "value": (_vm.search.idNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "idNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.yob1),
      expression: "search.yob1"
    }],
    staticClass: "input-group-text",
    attrs: {
      "type": "text",
      "name": "yob1",
      "placeholder": ("" + (_vm.$t('ageMin')))
    },
    domProps: {
      "value": (_vm.search.yob1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "yob1", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.yob2),
      expression: "search.yob2"
    }],
    staticClass: "input-group-text",
    attrs: {
      "type": "text",
      "name": "yob2",
      "placeholder": ("" + (_vm.$t('ageMax')))
    },
    domProps: {
      "value": (_vm.search.yob2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "yob2", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.gender),
      expression: "search.gender"
    }],
    staticClass: "input-group-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.search, "gender", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('gender')))]), _vm._v(" "), _vm._l((_vm.$t('sex')), function(s, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": i
      }
    }, [_vm._v("\n                           " + _vm._s(s) + "\n                          ")])
  })], 2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.address),
      expression: "search.address"
    }],
    staticClass: "input-group-text",
    attrs: {
      "type": "text",
      "name": "address",
      "placeholder": ("" + (_vm.$t('address')))
    },
    domProps: {
      "value": (_vm.search.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "address", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.city),
      expression: "search.city"
    }],
    staticClass: "input-group-text",
    attrs: {
      "type": "text",
      "name": "city",
      "placeholder": ("" + (_vm.$t('city')))
    },
    domProps: {
      "value": (_vm.search.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "city", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.zipcode),
      expression: "search.zipcode"
    }],
    staticClass: "input-group-text",
    attrs: {
      "type": "text",
      "name": "zipcode",
      "placeholder": ("" + (_vm.$t('zipcode')))
    },
    domProps: {
      "value": (_vm.search.zipcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "zipcode", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.status),
      expression: "search.status"
    }],
    staticClass: "input-group-select",
    attrs: {
      "placeholder": ("" + (_vm.$t('statusLbl')))
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.search, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('statusLbl')))]), _vm._v(" "), _vm._l((_vm.$t('rationRequestStatus')), function(s, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": i
      }
    }, [_vm._v("\n          " + _vm._s(s) + "\n          ")])
  })], 2), _vm._v(" "), _c('span', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-success padding5",
    on: {
      "click": _vm.searchClick
    }
  }, [_vm._v(_vm._s(_vm.$t('search')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-success padding5",
    on: {
      "click": _vm.clearClick
    }
  }, [_vm._v(_vm._s(_vm.$t('clear')))])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped"
  }, [_c('tbody', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "10px"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('contactNumber')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('name')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('idNumber')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('age')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('gender')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('address')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('city')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('state')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('zipcode')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('insertTime')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('status')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('action')) + " ")])]), _vm._v(" "), _vm._l((_vm.requestforrations), function(requestforration) {
    return _c('tr', {
      key: requestforration.id
    }, [_c('td'), _vm._v(" "), _c('td', [_vm._v("\n" + _vm._s(requestforration.contactNumber) + "\n")]), _vm._v(" "), _c('td', [_vm._v("\n" + _vm._s(requestforration.name) + "\n")]), _vm._v(" "), _c('td', [_vm._v("\n" + _vm._s(requestforration.idNumber) + "\n")]), _vm._v(" "), _c('td', [_vm._v("\n" + _vm._s(_vm.currentYear - requestforration.yob) + " \n")]), _vm._v(" "), _c('td', [_vm._v("\n" + _vm._s(_vm.$t('sex')[[requestforration.gender]]) + "\n\t")]), _c('td', [_vm._v("\n" + _vm._s(requestforration.address) + "\n")]), _vm._v(" "), _c('td', [_vm._v("\n" + _vm._s(requestforration.city) + "\n")]), _vm._v(" "), _c('td', [_vm._v("\n" + _vm._s(requestforration.state) + "\n")]), _vm._v(" "), _c('td', [_vm._v("\n" + _vm._s(requestforration.zipcode) + "\n")]), _vm._v(" "), _c('td', [_vm._v("\n\n        " + _vm._s(_vm.moment(requestforration.insertTime).startOf('hour').fromNow()) + "\n        \n")]), _vm._v(" "), _c('td', [_vm._v("\n\n      " + _vm._s(_vm.$t('rationRequestStatus')[[requestforration.status]]) + "\n      \n")]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          return _vm.openFrom(requestforration)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit fa-2x"
    })])])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "card-footer pb-0 pt-3"
  }, [_c('simple-pagination', {
    attrs: {
      "currentpage": _vm.search.page,
      "pages": _vm.search.totalpages
    },
    on: {
      "changePage": _vm.pageChange
    }
  })], 1)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-77b5e44f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/RequestForRation.vue
// module id = 729
// module chunks = 1